import { render, staticRenderFns } from "./SidebarBooker.vue?vue&type=template&id=2db210e4&scoped=true"
import script from "./SidebarBooker.vue?vue&type=script&lang=js"
export * from "./SidebarBooker.vue?vue&type=script&lang=js"
import style0 from "./SidebarBooker.vue?vue&type=style&index=0&id=2db210e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db210e4",
  null
  
)

export default component.exports